import { useContext, useState } from 'react'
import { InspectorContext } from './InspectorContext'

interface InspectorProps {
  files: string[]
}

const useInspectorContent = ({ files }: InspectorProps) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [zoom, setZoom] = useState(false)

  const { disabled } = useContext(InspectorContext)

  const activeImgSrc = files?.length ? files[currentIndex] : ''

  const handleNext = () => {
    if (disabled) return
    // First click → zoom current image
    if (!zoom) {
      setZoom(true)
      return
    }
    // Second click → next image, reset zoom
    setZoom(false)
    setCurrentIndex((prev) => (prev + 1 < files.length ? prev + 1 : 0))
  }

  return {
    activeImgSrc,
    zoom,
    disabled,
    files,
    handlers: {
      handleNext,
    },
  }
}

export default useInspectorContent
